import { render, staticRenderFns } from "./SingleShiftCard.vue?vue&type=template&id=536aa304"
import script from "./SingleShiftCard.vue?vue&type=script&lang=js"
export * from "./SingleShiftCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports